/**
 * FaceSwap 选项配置 - 国际化版本
 * 使用翻译键引用，支持多语言
 * 严格按照faceSwapRoleOptions.js国际化文件结构
 */

export const roleOptions = [
  {
    name: "aiWorkbench.faceSwap.categories.role",
    key: "role",
    children: [
      {
        name: "aiWorkbench.faceSwapeRoleOptions.gender.label",
        key: "gender",
        options: [
          { key: "Man", label: "aiWorkbench.faceSwapeRoleOptions.gender.options.man" },
          { key: "Woman", label: "aiWorkbench.faceSwapeRoleOptions.gender.options.woman" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.age.label",
        key: "age",
        options: [
          { key: "Baby (0-2)", label: "aiWorkbench.faceSwapeRoleOptions.age.options.baby" },
          { key: "Child (3-12)", label: "aiWorkbench.faceSwapeRoleOptions.age.options.child" },
          { key: "Teenager (13-19)", label: "aiWorkbench.faceSwapeRoleOptions.age.options.teenager" },
          { key: "Young Adult (20-39)", label: "aiWorkbench.faceSwapeRoleOptions.age.options.youngAdult" },
          { key: "Middle-aged (40-59)", label: "aiWorkbench.faceSwapeRoleOptions.age.options.middleAged" },
          { key: "Senior (60+)", label: "aiWorkbench.faceSwapeRoleOptions.age.options.senior" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.expression.label",
        key: "expression",
        options: [
          { key: "Happy", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.happy" },
          { key: "Laughing", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.laughing" },
          { key: "Serious", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.serious" },
          { key: "Calm", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.calm" },
          { key: "Surprised", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.surprised" },
          { key: "Sad", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.sad" },
          { key: "Angry", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.angry" },
          { key: "Thoughtful", label: "aiWorkbench.faceSwapeRoleOptions.expression.options.thoughtful" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.eyeColor.label",
        key: "eye_color",
        options: [
          { key: "Black", label: "aiWorkbench.faceSwapeRoleOptions.eyeColor.options.black" },
          { key: "Brown", label: "aiWorkbench.faceSwapeRoleOptions.eyeColor.options.brown" },
          { key: "Blue", label: "aiWorkbench.faceSwapeRoleOptions.eyeColor.options.blue" },
          { key: "Green", label: "aiWorkbench.faceSwapeRoleOptions.eyeColor.options.green" },
          { key: "Gray", label: "aiWorkbench.faceSwapeRoleOptions.eyeColor.options.gray" },
          { key: "Hazel", label: "aiWorkbench.faceSwapeRoleOptions.eyeColor.options.hazel" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.hairStyle.label",
        key: "hair_style",
        options: [
          { key: "Buzz cut", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.buzzCut" },
          { key: "Crew cut", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.crewCut" },
          { key: "Pixie cut", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.pixieCut" },
          { key: "Bob cut", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.bobCut" },
          { key: "Shoulder-length", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.shoulderLength" },
          { key: "Long straight", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.longStraight" },
          { key: "Long wavy", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.longWavy" },
          { key: "Curly", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.curly" },
          { key: "Afro", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.afro" },
          { key: "Ponytail", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.ponytail" },
          { key: "High bun", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.highBun" },
          { key: "Low bun", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.lowBun" },
          { key: "Bald", label: "aiWorkbench.faceSwapeRoleOptions.hairStyle.options.bald" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.hairColor.label",
        key: "hair_color",
        options: [
          { key: "Black", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.black" },
          { key: "Dark brown", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.darkBrown" },
          { key: "Light brown", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.lightBrown" },
          { key: "Blonde", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.blonde" },
          { key: "Platinum blonde", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.platinumBlonde" },
          { key: "Red", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.red" },
          { key: "Auburn", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.auburn" },
          { key: "Gray", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.gray" },
          { key: "White", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.white" },
          { key: "Colorful", label: "aiWorkbench.faceSwapeRoleOptions.hairColor.options.colorful" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.beard.label",
        key: "beard",
        options: [
          { key: "Clean shaven", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.cleanShaven" },
          { key: "5 o'clock shadow", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.fiveOClockShadow" },
          { key: "Light stubble", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.lightStubble" },
          { key: "Heavy stubble", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.heavyStubble" },
          { key: "Goatee", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.goatee" },
          { key: "Van Dyke", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.vanDyke" },
          { key: "Full beard", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.fullBeard" },
          { key: "Handlebar mustache", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.handlebarMustache" },
          { key: "Pencil mustache", label: "aiWorkbench.faceSwapeRoleOptions.beard.options.pencilMustache" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.nationality.label",
        key: "nationality",
        options: [
          { key: "Afghan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.afghan" },
          { key: "Albanian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.albanian" },
          { key: "Algerian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.algerian" },
          { key: "American", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.american" },
          { key: "Andorran", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.andorran" },
          { key: "Angolan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.angolan" },
          { key: "Argentine", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.argentine" },
          { key: "Armenian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.armenian" },
          { key: "Australian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.australian" },
          { key: "Austrian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.austrian" },
          { key: "Azerbaijani", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.azerbaijani" },
          { key: "Bahamian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bahamian" },
          { key: "Bahraini", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bahraini" },
          { key: "Bangladeshi", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bangladeshi" },
          { key: "Barbadian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.barbadian" },
          { key: "Belarusian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.belarusian" },
          { key: "Belgian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.belgian" },
          { key: "Belizean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.belizean" },
          { key: "Beninese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.beninese" },
          { key: "Bhutanese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bhutanese" },
          { key: "Bolivian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bolivian" },
          { key: "Brazilian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.brazilian" },
          { key: "British", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.british" },
          { key: "Bruneian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bruneian" },
          { key: "Bulgarian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.bulgarian" },
          { key: "Burkinabe", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.burkinabe" },
          { key: "Burundian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.burundian" },
          { key: "Cambodian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.cambodian" },
          { key: "Cameroonian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.cameroonian" },
          { key: "Canadian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.canadian" },
          { key: "Cape Verdian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.capeVerdian" },
          { key: "Chadian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.chadian" },
          { key: "Chilean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.chilean" },
          { key: "Chinese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.chinese" },
          { key: "Colombian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.colombian" },
          { key: "Congolese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.congolese" },
          { key: "Costa Rican", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.costaRican" },
          { key: "Croatian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.croatian" },
          { key: "Cuban", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.cuban" },
          { key: "Cypriot", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.cypriot" },
          { key: "Czech", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.czech" },
          { key: "Danish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.danish" },
          { key: "Dominican", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.dominican" },
          { key: "Dutch", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.dutch" },
          { key: "Ecuadorean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.ecuadorean" },
          { key: "Egyptian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.egyptian" },
          { key: "Emirian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.emirian" },
          { key: "Estonian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.estonian" },
          { key: "Ethiopian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.ethiopian" },
          { key: "Fijian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.fijian" },
          { key: "Filipino", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.filipino" },
          { key: "Finnish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.finnish" },
          { key: "French", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.french" },
          { key: "Gabonese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.gabonese" },
          { key: "Gambian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.gambian" },
          { key: "Georgian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.georgian" },
          { key: "German", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.german" },
          { key: "Ghanaian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.ghanaian" },
          { key: "Greek", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.greek" },
          { key: "Guatemalan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.guatemalan" },
          { key: "Guinean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.guinean" },
          { key: "Haitian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.haitian" },
          { key: "Honduran", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.honduran" },
          { key: "Hungarian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.hungarian" },
          { key: "Icelander", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.icelander" },
          { key: "Indian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.indian" },
          { key: "Indonesian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.indonesian" },
          { key: "Iranian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.iranian" },
          { key: "Iraqi", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.iraqi" },
          { key: "Irish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.irish" },
          { key: "Israeli", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.israeli" },
          { key: "Italian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.italian" },
          { key: "Ivorian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.ivorian" },
          { key: "Jamaican", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.jamaican" },
          { key: "Japanese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.japanese" },
          { key: "Jordanian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.jordanian" },
          { key: "Kazakhstani", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.kazakhstani" },
          { key: "Kenyan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.kenyan" },
          { key: "North Korean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.northKorean" },
          { key: "South Korean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.southKorean" },
          { key: "Kuwaiti", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.kuwaiti" },
          { key: "Kyrgyz", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.kyrgyz" },
          { key: "Laotian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.laotian" },
          { key: "Latvian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.latvian" },
          { key: "Lebanese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.lebanese" },
          { key: "Liberian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.liberian" },
          { key: "Libyan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.libyan" },
          { key: "Lithuanian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.lithuanian" },
          { key: "Luxembourgish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.luxembourgish" },
          { key: "Macedonian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.macedonian" },
          { key: "Malagasy", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.malagasy" },
          { key: "Malawian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.malawian" },
          { key: "Malaysian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.malaysian" },
          { key: "Maldivan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.maldivan" },
          { key: "Malian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.malian" },
          { key: "Maltese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.maltese" },
          { key: "Mauritanian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.mauritanian" },
          { key: "Mauritian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.mauritian" },
          { key: "Mexican", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.mexican" },
          { key: "Moldovan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.moldovan" },
          { key: "Mongolian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.mongolian" },
          { key: "Montenegrin", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.montenegrin" },
          { key: "Moroccan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.moroccan" },
          { key: "Mozambican", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.mozambican" },
          { key: "Namibian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.namibian" },
          { key: "Nepalese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.nepalese" },
          { key: "New Zealander", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.newZealander" },
          { key: "Nicaraguan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.nicaraguan" },
          { key: "Nigerian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.nigerian" },
          { key: "Norwegian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.norwegian" },
          { key: "Pakistani", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.pakistani" },
          { key: "Panamanian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.panamanian" },
          { key: "Paraguayan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.paraguayan" },
          { key: "Peruvian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.peruvian" },
          { key: "Polish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.polish" },
          { key: "Portuguese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.portuguese" },
          { key: "Qatari", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.qatari" },
          { key: "Romanian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.romanian" },
          { key: "Russian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.russian" },
          { key: "Rwandan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.rwandan" },
          { key: "Salvadoran", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.salvadoran" },
          { key: "Saudi", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.saudi" },
          { key: "Scottish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.scottish" },
          { key: "Senegalese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.senegalese" },
          { key: "Serbian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.serbian" },
          { key: "Singaporean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.singaporean" },
          { key: "Slovakian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.slovakian" },
          { key: "Slovenian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.slovenian" },
          { key: "Somali", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.somali" },
          { key: "South African", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.southAfrican" },
          { key: "Spanish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.spanish" },
          { key: "Sri Lankan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.sriLankan" },
          { key: "Sudanese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.sudanese" },
          { key: "Swedish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.swedish" },
          { key: "Swiss", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.swiss" },
          { key: "Syrian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.syrian" },
          { key: "Thai", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.thai" },
          { key: "Togolese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.togolese" },
          { key: "Tunisian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.tunisian" },
          { key: "Turkish", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.turkish" },
          { key: "Ugandan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.ugandan" },
          { key: "Ukrainian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.ukrainian" },
          { key: "Uruguayan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.uruguayan" },
          { key: "Uzbekistani", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.uzbekistani" },
          { key: "Venezuelan", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.venezuelan" },
          { key: "Vietnamese", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.vietnamese" },
          { key: "Welsh", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.welsh" },
          { key: "Yemeni", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.yemeni" },
          { key: "Zambian", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.zambian" },
          { key: "Zimbabwean", label: "aiWorkbench.faceSwapeRoleOptions.nationality.options.zimbabwean" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.bodyWeight.label",
        key: "body_weight",
        options: [
          { key: "Underweight", label: "aiWorkbench.faceSwapeRoleOptions.bodyWeight.options.underweight" },
          { key: "Normal weight", label: "aiWorkbench.faceSwapeRoleOptions.bodyWeight.options.normalWeight" },
          { key: "Overweight", label: "aiWorkbench.faceSwapeRoleOptions.bodyWeight.options.overweight" },
          { key: "Obese", label: "aiWorkbench.faceSwapeRoleOptions.bodyWeight.options.obese" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.faceShape.label",
        key: "face_shape",
        options: [
          { key: "Oval", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.oval" },
          { key: "Round", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.round" },
          { key: "Square", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.square" },
          { key: "Heart-shaped", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.heartShaped" },
          { key: "Long", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.long" },
          { key: "Rectangle", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.rectangle" },
          { key: "Triangle", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.triangle" },
          { key: "Inverted Triangle", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.invertedTriangle" },
          { key: "Pear-shaped", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.pearShaped" },
          { key: "Oblong", label: "aiWorkbench.faceSwapeRoleOptions.faceShape.options.oblong" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.label",
        key: "facial_feature_details",
        options: [
          { key: "High nose bridge", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.highNoseBridge" },
          { key: "Short nose", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.shortNose" },
          { key: "Large eyes", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.largeEyes" },
          { key: "Small eyes", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.smallEyes" },
          { key: "High cheekbones", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.highCheekbones" },
          { key: "Small mouth", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.smallMouth" },
          { key: "Full lips", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.fullLips" },
          { key: "Perfect teeth", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.perfectTeeth" },
          { key: "Squint", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.squint" },
          { key: "Natural expression", label: "aiWorkbench.faceSwapeRoleOptions.facialFeatureDetails.options.naturalExpression" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.label",
        key: "eye_features",
        options: [
          { key: "Double eyelids", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.doubleEyelids" },
          { key: "Single eyelids", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.singleEyelids" },
          { key: "Inner double eyelids", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.innerDoubleEyelids" },
          { key: "Deep-set eyes", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.deepSetEyes" },
          { key: "Bags under eyes", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.bagsUnderEyes" },
          { key: "Eyeshadow effect", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.eyeshadowEffect" },
          { key: "Eyeliner", label: "aiWorkbench.faceSwapeRoleOptions.eyeFeatures.options.eyeliner" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.ears.label",
        key: "ears",
        options: [
          { key: "Visible ears", label: "aiWorkbench.faceSwapeRoleOptions.ears.options.visibleEars" },
          { key: "Hidden ears", label: "aiWorkbench.faceSwapeRoleOptions.ears.options.hiddenEars" },
          { key: "Large ears", label: "aiWorkbench.faceSwapeRoleOptions.ears.options.largeEars" },
          { key: "Small ears", label: "aiWorkbench.faceSwapeRoleOptions.ears.options.smallEars" },
          { key: "Pierced ears", label: "aiWorkbench.faceSwapeRoleOptions.ears.options.piercedEars" },
          { key: "Earrings", label: "aiWorkbench.faceSwapeRoleOptions.ears.options.earrings" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.skinDetails.label",
        key: "skin_details",
        options: [
          { key: "Smooth skin", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.smoothSkin" },
          { key: "Spotted skin", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.spottedSkin" },
          { key: "Dull skin", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.dullSkin" },
          { key: "Healthy glow", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.healthyGlow" },
          { key: "Natural skin tone", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.naturalSkinTone" },
          { key: "Acne/Freckles", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.acneFreckles" },
          { key: "Wrinkles/Aged look", label: "aiWorkbench.faceSwapeRoleOptions.skinDetails.options.wrinklesAgedLook" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.skinTextureEffect.label",
        key: "skin_texture_effect",
        options: [
          { key: "Flawless skin", label: "aiWorkbench.faceSwapeRoleOptions.skinTextureEffect.options.flawlessSkin" },
          { key: "Textured skin", label: "aiWorkbench.faceSwapeRoleOptions.skinTextureEffect.options.texturedSkin" },
          { key: "Matte skin", label: "aiWorkbench.faceSwapeRoleOptions.skinTextureEffect.options.matteSkin" },
          { key: "Glossy skin", label: "aiWorkbench.faceSwapeRoleOptions.skinTextureEffect.options.glossySkin" },
          { key: "Enhanced detail texture", label: "aiWorkbench.faceSwapeRoleOptions.skinTextureEffect.options.enhancedDetailTexture" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.label",
        key: "clothing_style",
        options: [
          { key: "Formal wear", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.formalWear" },
          { key: "Suit", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.suit" },
          { key: "Business attire", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.businessAttire" },
          { key: "Evening attire", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.eveningAttire" },
          { key: "Casual wear", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.casualWear" },
          { key: "Sportswear", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.sportswear" },
          { key: "Uniform", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.uniform" },
          { key: "Wedding attire", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.weddingAttire" },
          { key: "Traditional costume", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.traditionalCostume" },
          { key: "Vintage/Retro clothing", label: "aiWorkbench.faceSwapeRoleOptions.clothingStyle.options.vintageRetroClothing" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.clothingTexture.label",
        key: "clothing_texture",
        options: [
          { key: "Silk/Glossy texture", label: "aiWorkbench.faceSwapeRoleOptions.clothingTexture.options.silkGlossyTexture" },
          { key: "Sweater texture", label: "aiWorkbench.faceSwapeRoleOptions.clothingTexture.options.sweaterTexture" },
          { key: "Leather texture", label: "aiWorkbench.faceSwapeRoleOptions.clothingTexture.options.leatherTexture" },
          { key: "Printed pattern", label: "aiWorkbench.faceSwapeRoleOptions.clothingTexture.options.printedPattern" },
          { key: "Denim texture", label: "aiWorkbench.faceSwapeRoleOptions.clothingTexture.options.denimTexture" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeRoleOptions.headAccessories.label",
        key: "head_accessories",
        options: [
          { key: "Hat", label: "aiWorkbench.faceSwapeRoleOptions.headAccessories.options.hat" },
          { key: "Glasses", label: "aiWorkbench.faceSwapeRoleOptions.headAccessories.options.glasses" },
          { key: "Jewelry", label: "aiWorkbench.faceSwapeRoleOptions.headAccessories.options.jewelry" },
          { key: "Hair accessories", label: "aiWorkbench.faceSwapeRoleOptions.headAccessories.options.hairAccessories" },
          { key: "Face accessories", label: "aiWorkbench.faceSwapeRoleOptions.headAccessories.options.faceAccessories" }
        ]
      }
    ]
  }
];

export default roleOptions;